import React from "react";
import { View, Text } from "react-native";

export const waitingForParticipants = () => {
  console.log(`waitingForParticipants`);
  return (
    <View
      style={{
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Text>Oczekiwanie na pozostałych uczestników</Text>
    </View>
  );
};
